import { mapGetters, } from 'vuex';

export default {
  name: 'BaseRequestError',
  props: {
    message: {
      type: Object,
      default: () => ({
        code: 404,
        text: 'Esta página não foi encontrada :(',
        icon: require('@/assets/img-notfound.svg',),
      }),
    },
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
    },),
    route () {
      return (this.user.businessType === 'Franqueadora') ? 'root' : 'franchise-root';
    },
  },
};
